/* eslint-disable import/prefer-default-export */
import type * as Actions from '@src/redux/actions/identities/identities.actions'
import * as FilterActions from '@src/redux/actions/filter.actions'
import * as ActionTypes from '@src/redux/actionTypes/identities.action.types'
import * as FilterActionTypes from '@src/redux/actionTypes/filter.action.types'
import { getGraph } from '@src/utils/redux.tools'
import { defaultState, IdentitiesState } from './default.state'

export type IdentitiesActionTypes =
  | Actions.ActionTypes
  | FilterActions.ActionTypes

export function reducer(
  state = defaultState,
  action: IdentitiesActionTypes
): IdentitiesState {
  switch (action.type) {
    case ActionTypes.CHANGE_STATE: {
      const { payload } = action
      return {
        ...state,
        ...payload
      }
    }
    case ActionTypes.GET_STAT_SUCCESS: {
      return {
        ...state,
        [action.payload.stat]: action.payload.value,
        isPending: false
      }
    }
    case ActionTypes.CLEANER_STAT: {
      return {
        ...state,
        [action.payload.stat]: defaultState[action.payload.stat]
      }
    }
    case ActionTypes.DETAILS_CLEANER: {
      return {
        ...state,
        objects: defaultState.objects,
        objectList: defaultState.objectList,
        countOfPrivileges: defaultState.countOfPrivileges,
        countOfUTPrivileges: defaultState.countOfUTPrivileges,
        priviligeList: defaultState.priviligeList,
        membership: defaultState.membership,
        roleList: defaultState.roleList,
        countOfMembers: defaultState.countOfMembers,
        countOfScopes: defaultState.countOfScopes,
        scopeList: defaultState.scopeList,
        memberList: defaultState.memberList,
        countOfUsers: defaultState.countOfUsers,
        displayName: defaultState.displayName,
        displayScopeName: defaultState.displayScopeName,
        userList: defaultState.userList,
        countOfInstances: defaultState.countOfInstances,
        instanceList: defaultState.instanceList
      }
    }

    case ActionTypes.GET_USER_LOCATION_SERVER_ERRORS: {
      return {
        ...state,
        errors: action.payload.errors,
        isPending: false
      }
    }
    case ActionTypes.SERVER_ERRORS: {
      return {
        ...state,
        errors: action.payload.errors,
        isPending: action.payload.isPending,
        isPendingGraph: false
      }
    }
    case ActionTypes.REQUEST_PENDING_GRAPH: {
      return {
        ...state,
        isPendingGraph: action.payload.isPending
      }
    }

    case ActionTypes.SEARCH_RESULTS_SUCCESS: {
      const { graph, objectList } = action.payload
      return {
        ...state,
        ...getGraph({ state, graph }),
        objectList,
        isPending: false
      }
    }

    case ActionTypes.REQUEST_PENDING: {
      const { isPending } = action.payload
      return {
        ...state,
        isPending: action.payload.isPending,
        overviewList: isPending ? [] : state.overviewList
      }
    }

    case FilterActionTypes.APPLY_NOW:
    case FilterActionTypes.RESET_ALL: {
      return {
        ...state,
        isPending: defaultState.isPending,
        overviewList: defaultState.overviewList
      }
    }
    case ActionTypes.CLEANING: {
      return defaultState
    }

    case ActionTypes.DISPOSE_DETAILS: {
      return {
        ...state,
        displayName: defaultState.displayName,
        displayScopeName: defaultState.displayScopeName,
        selectedGraphView: defaultState.selectedGraphView,
        selectedTile: defaultState.selectedTile,
        graph: defaultState.graph,
        infoDetails: defaultState.infoDetails,
        countOfUTPrivileges: defaultState.countOfUTPrivileges
      }
    }

    case ActionTypes.GET_IDENTITIES_OVERVIEW_STATS_DATA: {
      const { data, type } = action?.payload || {}
      const { list, totals } = data || {}
      return {
        ...state,
        isPending: false,
        overviewList: list ?? state.overviewList,
        totals: totals ?? state.totals,
        selectedIdentityType: type ?? state.selectedIdentityType
      }
    }

    case ActionTypes.SET_SELECTED_TILE: {
      return {
        ...state,
        selectedTile: action.payload.tile,
        selectedCounter: action.payload.counter
      }
    }

    case ActionTypes.GET_IDENTITY_DETAILS_COUNTS_DATA: {
      const { data = {} as IdentitiesState } = action?.payload
      return {
        ...state,
        ...data,
        isPending: false,
        selectedTile: defaultState.selectedTile
      }
    }

    case ActionTypes.GET_IDENTITY_DETAILS_TABLE_DATA: {
      const { data = {} as IdentitiesState } = action?.payload
      return {
        ...state,
        ...data,
        isPending: false
      }
    }

    case ActionTypes.GET_IDENTITY_DETAILS_GRAPH_DATA: {
      const { graph, isPendingGraph } = action.payload
      return {
        ...state,
        ...getGraph({ state, graph }),
        isPendingGraph
      }
    }

    default: {
      return state
    }
  }
}
